import { useLang, IMAGES } from "../../App";

const LoanCard = ({ data, image, watermark, featured, testid }) => (
  <div
    data-testid={testid}
    className={
      featured
        ? "rounded-2xl border border-[#fbbf24]/40 bg-slate-900/80 p-8 relative shadow-xl shadow-black/40"
        : "rounded-2xl border border-slate-700 bg-slate-900/50 p-8 hover:border-[#fbbf24]/50 transition-colors"
    }
  >
    <div className="h-44 rounded-xl mb-6 relative overflow-hidden">
      <img src={image} alt={data.name} className="absolute inset-0 w-full h-full object-cover" />
      <div className={`absolute inset-0 ${featured ? "bg-[#070d1e]/60" : "bg-[#070d1e]/55"}`}></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className={`disp text-3xl font-black ${featured ? "text-[#fbbf24]/30" : "text-white/25"}`}>{watermark}</span>
      </div>
    </div>
    <div className="flex items-center justify-between mb-3">
      <h3 className="disp text-2xl font-bold text-white">{data.name}</h3>
      <span
        className={
          featured
            ? "mono text-xs font-semibold px-3 py-1 bg-[#fbbf24] text-[#070d1e] rounded-full"
            : "mono text-xs font-semibold px-3 py-1 bg-[#fbbf24]/10 text-[#fbbf24] rounded-full border border-[#fbbf24]/30"
        }
      >
        {data.badge}
      </span>
    </div>
    <p className="text-sm text-slate-300 mb-6">{data.desc}</p>
    <ul className="mono text-xs space-y-2 text-slate-400 mb-6">
      {data.bullets.map((b, i) => (
        <li key={i} className="flex items-center gap-2">
          <span className="text-[#fbbf24]">&#10003;</span> {b}
        </li>
      ))}
    </ul>
    <a
      href="#apply"
      data-testid={`${testid}-cta`}
      className={
        featured
          ? "block text-center disp text-xs font-bold uppercase tracking-wider py-3 bg-[#fbbf24] text-[#070d1e] hover:bg-[#f59e0b] rounded transition-colors"
          : "block text-center disp text-xs font-bold uppercase tracking-wider py-3 border border-slate-600 hover:border-[#fbbf24] hover:text-[#fbbf24] rounded transition-colors"
      }
    >
      {data.cta}
    </a>
  </div>
);

export const LoanTypes = () => {
  const { t } = useLang();
  return (
    <section id="types" className="py-24 border-b border-[#1e293b]/60" data-testid="loan-types-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-14">
          <span className="mono text-xs uppercase tracking-widest text-[#fbbf24]">{t("types.eyebrow")}</span>
          <h2 className="disp text-3xl sm:text-4xl font-bold text-white mt-2">{t("types.title")}</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <LoanCard data={t("types.personal")} image={IMAGES.personal} watermark="PERSONAL" testid="personal-loan-card" />
          <LoanCard data={t("types.business")} image={IMAGES.business} watermark="BUSINESS" featured testid="business-loan-card" />
        </div>
      </div>
    </section>
  );
};
